import React from 'react';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';

type BaseProps = React.DetailedHTMLProps<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>;

type FormProps<T extends FieldValues> = Omit<BaseProps, 'form' | 'name'> & {
  form: UseFormReturn<T>;
  name: Path<T>;
};

export type TextAreaProps<T extends FieldValues> = BaseProps | FormProps<T>;

const defaultClasses = {
  className: 'h-8 px-3 py-2 rounded-xl border border-gray-cb resize-none',
};

export const TextArea = Object.assign(TextAreaComponent, defaultClasses);

function TextAreaComponent<T extends FieldValues>({
  className = defaultClasses.className,
  onChange,
  form,
  name,
  ...props
}: TextAreaProps<T>) {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const el = e.target;
    // adjust height when adding or removing line breaks
    el.style.height = '';
    el.style.height = `${e.target.scrollHeight + 2}px`;
    onChange?.(e);
  };

  return (
    <textarea
      {...props}
      {...(typeof form === 'object'
        ? form.register(name as Path<T>, { onChange: handleChange })
        : undefined)}
      className={className}
      name={name}
      onChange={onChange ? handleChange : undefined}
    />
  );
}
